import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Personal API keys can enable full access to your account, like logging in with your email and password. You can create multiple, give them different scopes, and each can be invalidated individually. This improves the security of your PostHog account. Personal API keys need to be kept private and shouldn't be used in the frontend.`}</p>
    <h4 {...{
      "id": "how-to-obtain-a-personal-api-key"
    }}>{`How to obtain a personal API key`}</h4>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to the `}<a parentName="p" {...{
            "href": "https://us.posthog.com/settings/user-api-keys"
          }}>{`Personal API keys`}</a>{` section in your account settings`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`+ Create a personal API Key`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Give your key a label - this is just for you, usually to describe the key's purpose.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Choose the scopes for your key. We recommended selecting only the scopes required for the API endpoints you really need. This is a security best practice. You can always modify the scopes later if you need to.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`At the top of the list, you should see your brand new key. `}<strong parentName="p">{`Immediately`}</strong>{` copy its value, as you'll `}<strong parentName="p">{`never`}</strong>{` see it again after refreshing the page.`}</p>
      </li>
    </ol>
    <p>{`You can create as many keys as you like. Personal API keys are deleted when a user is deleted.`}</p>
    <p><img parentName="p" {...{
        "src": "https://res.cloudinary.com/dmukukwp6/image/upload/v1710055416/posthog.com/contents/images/docs/api/create-api-key.png",
        "alt": "How to create an api key"
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      